<script lang="ts">
  import clsx from 'clsx';
  import { Paragraph } from '@athena-lib/Text';
  import { TextLink } from '@athena-lib/TextLink';
  import { Stack, StackItem } from '@athena-lib/Stack';
  import Image from '@athena-lib/Image/Image.svelte';
  import { Star } from '@athena-lib/Icons';
  import { setContainerContextWidth } from '@athena-lib/container-context.svelte';
  import type { EndorsementCardProps } from '../types';
  import Card from '../Card/Card.svelte';

  setContainerContextWidth({
    sm: 0.25,
    md: 0.15,
    lg: 0.1,
  });

  let { logo, endorsedBy, quote, class: className, ...props }: EndorsementCardProps = $props();
</script>

<Card
  padding="none"
  shadow={false}
  useMinHeight={false}
  rounded={false}
  class={clsx(className, 'h-full')}
  {...props}
  aspect="auto"
>
  <div class="flex h-full flex-col justify-between gap-gutter">
    <Stack>
      <StackItem class="aspect-square h-24">
        <Image imgClass="max-w-24" src={logo.url} alt={logo.alt} loading="lazy" />
      </StackItem>
      <StackItem class="flex gap-1 text-st-gray-800">
        {#each new Array(5) as _}
          <Star sizeClass="h-3" />
        {/each}
      </StackItem>
      <StackItem>
        <Paragraph size={{ sm: 'small', md: 'medium' }}>{quote}</Paragraph>
      </StackItem>
    </Stack>
    <Stack space="none">
      <StackItem class="font-bold">
        {endorsedBy.name}
      </StackItem>
      {#if endorsedBy.url}
        <StackItem>
          <TextLink class="text-st-gray-600 underline" href={endorsedBy.url} isExternal={true}>
            {endorsedBy.url.replace(/^https:\/\//, '')}
          </TextLink>
        </StackItem>
      {/if}
    </Stack>
  </div>
</Card>
